export default function Services() {
  const services = [
    {
      icon: 'ri-tools-fill',
      title: 'AC Repair',
      description: 'Fast, reliable repairs to get your AC running smoothly again. Our experienced technicians diagnose and fix issues quickly.'
    },
    {
      icon: 'ri-refresh-line',
      title: 'AC Installation & Replacement',
      description: 'Professional installation of new AC systems with expert guidance on the best unit for your home and budget.'
    },
    {
      icon: 'ri-settings-3-fill',
      title: 'HVAC Maintenance',
      description: 'Regular maintenance keeps your system running efficiently and prevents costly breakdowns. Schedule your tune-up today.'
    },
    {
      icon: 'ri-wind-fill',
      title: 'Duct Cleaning',
      description: 'Improve air quality and system efficiency with professional duct cleaning services for your entire home.'
    },
    {
      icon: 'ri-fire-fill',
      title: 'Dryer Vent Cleaning',
      description: 'Prevent fire hazards and improve dryer efficiency with our thorough dryer vent cleaning service.'
    },
    {
      icon: 'ri-temp-cold-line',
      title: 'Mini Split Installation',
      description: 'Energy-efficient ductless mini split systems perfect for room additions, garages, and zone cooling.'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-orange-500 font-semibold text-sm uppercase tracking-wider mb-3">
            OUR SERVICES
          </p>
          <h2 className="text-5xl font-bold text-slate-900 mb-4">
            Complete HVAC Solutions for Your Home
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            From repairs to installations, we provide comprehensive HVAC services to keep your home comfortable year-round
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-blue-50 rounded-2xl p-10 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 hover:border-2 hover:border-orange-500 cursor-pointer group"
            >
              <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-3">
                {service.title}
              </h3>
              <p className="text-gray-600 text-base leading-relaxed mb-4">
                {service.description}
              </p>
              <a href="#contact" className="text-orange-500 font-semibold inline-flex items-center gap-2 hover:gap-3 transition-all cursor-pointer">
                Learn More
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          ))}
        </div>

        {/* Book a Service Button */}
        <div className="flex justify-center mb-12">
          <a
            href="#contact"
            className="inline-flex items-center gap-3 px-10 py-4 bg-orange-500 text-white text-lg font-bold rounded-full hover:bg-orange-600 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 shadow-lg whitespace-nowrap cursor-pointer"
          >
            <i className="ri-calendar-check-line text-2xl"></i>
            Book a Service
          </a>
        </div>

        {/* Special Offer Banner */}
        <div className="bg-orange-500 rounded-2xl p-8 text-center shadow-lg">
          <div className="flex items-center justify-center gap-4 flex-wrap">
            <i className="ri-phone-fill text-4xl text-white"></i>
            <p className="text-2xl md:text-3xl font-bold text-white">
              DIAGNOSTIC FEE $129 - FREE WITH REPAIR
            </p>
            <a 
              href="tel:9412233052" 
              className="px-8 py-3 bg-white text-orange-500 font-bold rounded-full hover:bg-slate-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              Call (941) 223-3052
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}